import styled from "styled-components";

const Copy = styled.div`
  margin: 0 ${({ theme }) => theme.space[2]};

  h4,
  h5,
  p,
  ul,
  ol,
  table {
    margin-bottom: ${({ theme }) => theme.space[2]};
  }

  h4 {
    margin-top: 14px;
    font-size: ${({ theme }) => theme.fontSizes[2]};
    font-weight: 600;
  }

  h6 {
    margin-bottom: ${({ theme }) => theme.space[1]};
  }

  h3 {
    font-size: ${({ theme }) => theme.fontSizes[3]};
  }

  ul,
  ol {
    margin-top: 0;
    margin-bottom: ${({ theme }) => theme.space[2]};
    padding-left: 4rem;
  }

  ul li {
    margin-bottom: ${({ theme }) => theme.space[2]};
  }
`;

export default Copy;
